import { useState } from "react";
import { ReactComponent as CollapseIcon } from "../../images/box-collapser.svg";
import { ReactComponent as SortIcon } from "../../images/sort.svg";
import utility from "core/Utils";

const Table = props => {
  const headers = props.headers || [];
  const data = props.data || [];
  const showPagination = "pagination" in props ? props.pagination : true;

  const [currentPage, setCurrentPage] = useState(0);
  const [perPage, setPerPage] = useState(8);
  const [sortedColumn, setSortedColumn] = useState("");

  if (!Object.keys(headers).length) {
    return <table></table>;
  }

  const updatePerPage = e => {
    let val = e.target.value;
    if (val === "") {
      val = 0;
    } else {
      val = parseInt(val);
      if (!val) {
        return;
      }
    }

    const maxPerPage = Math.min(data.length, 50);
    if (val > maxPerPage) {
      val = maxPerPage;
    }

    setPerPage(val);
  };

  const handlePageChange = e => {
    let val = e.target.value;
    if (val !== "") {
      val = parseInt(val);
      if (!val) {
        return;
      }
      updatePage(val - 1);
    } else {
      setCurrentPage(val);
    }
  };

  const updatePage = page => {
    const totalPage = Math.floor(data.length / perPage);
    if (page > totalPage) {
      page = totalPage;
    }

    setCurrentPage(page);
  };

  const prevPage = () => {
    if (currentPage === 0) {
      return;
    }
    updatePage(currentPage - 1);
  };

  const nextPage = () => {
    updatePage(currentPage + 1);
  };

  const startIndex = (currentPage === "" ? 0 : currentPage) * perPage;
  const endIndex = Math.min(startIndex + perPage, data.length);

  let isCSV = false;
  if (props.dataType && props.dataType.toLowerCase() === "csv") {
    isCSV = true;
  }

  let finalList = [];
  let isSearched = false;

  let minCharForSearch = 2;
  if (props.searchMinChar) {
    minCharForSearch = props.searchMinChar;
  }

  if (props.search && props.search.length >= minCharForSearch) {
    // search conditions
    isSearched = true;
    let searchKeyword = props.search.toLowerCase();

    for (let i = 0; i < data.length; i++) {
      let matched = false;
      for (let key in data[i]) {
        if (typeof data[i][key] === "object") {
          continue;
        }

        if (data[i][key] !== undefined) {
          if (data[i][key].toString().toLowerCase().includes(searchKeyword)) {
            matched = true;
            break;
          }
        }
      }

      if (matched) {
        finalList.push(data[i]);
      }
    }
  } else {
    finalList = data;
  }

  // sorting
  if (sortedColumn !== "") {
    finalList = finalList.sort(utility.dynamicSort(sortedColumn));
  }

  const renderList = finalList.slice(startIndex, endIndex);

  return (
    <div className="table-wrapper">
      <div className="table-data" style={{ maxHeight: "330px" }}>
        <table>
          <thead>
            <tr>
              {isCSV
                ? headers.map((head, index) => <th key={index}>{head}</th>)
                : Object.keys(headers).map((hkey, index) => (
                    <th
                      key={index}
                      onClick={() => {
                        if (hkey.toLowerCase().includes("action")) {
                          return;
                        }

                        let sortKey = hkey;
                        if (sortedColumn === sortKey) {
                          sortKey = "-" + sortKey;
                        }

                        setSortedColumn(sortKey);
                      }}
                    >
                      {headers[hkey]}

                      {hkey === sortedColumn && <SortIcon />}
                      {"-" + hkey === sortedColumn && (
                        <SortIcon style={{ transform: "rotate(-180deg)" }} />
                      )}
                    </th>
                  ))}
            </tr>
          </thead>
          <tbody>
            {renderList.map((row, i) => (
              <tr key={i}>
                {isCSV
                  ? row.map((col, j) => <td key={j}>{col}</td>)
                  : Object.keys(headers).map((head, j) => (
                      <td key={j}>{row[head]}</td>
                    ))}
              </tr>
            ))}
          </tbody>
        </table>
        {renderList.length === 0 && (
          <div className="row pad-1">
            <p className="info">There are no items to display</p>
          </div>
        )}
      </div>
      {showPagination && (
        <div className="table-pagination flex flex-v-center">
          <div className="left pad-1">
            Showing {startIndex + 1} - {endIndex} of{" "}
            {isSearched ? finalList.length : data.length}
          </div>
          <div className="right">
            <div className="flex flex-v-center">
              <div className="el">Show</div>
              <div className="el">
                <input
                  type="text"
                  value={perPage === 0 ? "" : perPage}
                  onChange={updatePerPage}
                />
              </div>
              <div className="el">
                <div
                  className="button prev flex flex-center"
                  onClick={prevPage}
                >
                  <CollapseIcon />
                </div>
              </div>
              <div className="el">Page</div>
              <div className="el">
                <input
                  type="text"
                  value={currentPage === "" ? "" : currentPage + 1}
                  onChange={handlePageChange}
                />
              </div>
              <div className="el">
                <div
                  className="button next flex flex-center"
                  onClick={nextPage}
                >
                  <CollapseIcon />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Table;
